/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import Pagination from "@material-ui/lab/Pagination";
import PaidIcon, { ReactComponent as Paidicon } from "assets/icons/PaidIcon.svg";
import PendingIcon from "assets/icons/PendingIcon.svg";
import { Text } from "components";
import AlertDialog from "components/Dialog/index";
import RightDrawer from "components/drawer";
import NotAuthorized from "components/NotAuthorized";
import { numberFormat } from "helper";
import PreSchoolService from "Lib/API/PreSchool/index";
import ShareDocumentsModal from "pages/NewFinance/Documents/ShareDocumentsModal";
import ParticipantDrawer from "pages/School/participants/ParticipantDetails/ParticipantDetailsTable/ParticipantDrawer/ParticipantDrawer";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router";
import thousands from "thousands";
import MyTable from "../../../../components/Table";
import { Status, StatusWrapper } from "../Theme";

const School = ({ member }) => {
	const [loading, setLoading] = useState(false);
	const [list, setList] = useState([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(0);
	const { getAccessTokenSilently } = useAuth0();
	const [openDrawer, setOpenDrawer] = useState(false);
	const [drawerData, setDrawerData] = useState({});
	const [openSharePaymentModal, setOpenSharePayment] = useState(false);
	const [dataRowSharePayment, setDataRowSharePayment] = useState({});
  const [isSchoolActive, setIsSchoolActive] = useState(false);
	const [confirmClose, setConfirmClose] = useState(false);


	let orgInfo = localStorage?.getItem("organization")
	? JSON.parse(localStorage?.getItem("organization"))
	: [];

let authorizedModulesInfo = localStorage?.getItem("authorizedModules")
	? JSON.parse(localStorage?.getItem("authorizedModules"))
	: [];


	useEffect(() => {
    const status = orgInfo?.authorizedModules?.find((item) => item?.moduleName === "education")?.active === true && 
    authorizedModulesInfo?.find((item) => item?.moduleName === "education")?.active === true ? true : false;
    
    setIsSchoolActive(status);
  }, []);


	const history = useHistory();

	const enableLoading = (value) => {
		setLoading(value);
	};

	const getClassParticipantsHandler = async () => {
		enableLoading(true);
		const token = await getAccessTokenSilently();
		const payload = {
			accountId: member?._id,
		};
		await PreSchoolService.getClassParticipantsByAccounts({ token, payload, page: page + 1, limit: 30 })
			.then((res) => {
				setList(res?.payload?.data || []);
				setTotal(res?.payload?.pagination?.count || 0);
			})
			.catch((error) => {
				toastr.error("Error", error?.data?.message || "Something went wrong!");
			})
			.finally(() => {
				enableLoading(false);
			});
	};

	React.useEffect(() => {
		getClassParticipantsHandler();
	}, [getAccessTokenSilently, history, page]);

	const onClickEvent = (data) => {
		setDrawerData(data?.row || {});
		setOpenDrawer(true);
	};

	const onSharePaymentLinkClick = (row) => {
    setDataRowSharePayment({
      account: member,
      _id: row?._id,
    });
    setOpenSharePayment(true);
	};

	const totalPaymentCalculation = (approveTotalPaid, registerTotalPaid) => {
		const totalPayment = numberFormat({number:+approveTotalPaid || 0 + +registerTotalPaid || 0, decimal:2,style:"currency"});
		return totalPayment;
	};

	const columns = [
		{
			field: "class_name",
			headerName: "CLASS",
			width: 150,
			align: "left",
			renderCell: (data) => {
				return <div className="row-data class-lits-table-cell">{data?.row?.class?.class_name}</div>;
			},
		},
		{
			field: "firstName",
			headerName: "STUDENT FIRST NAME",
			width: 200,
			// editable: true,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell">
					{data?.row?.firstName}
				</div>
			),
		},
		{
			field: "lastName",
			headerName: "STUDENT LAST NAME",
			width: 200,
			// editable: true,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell">
					{data?.row?.lastName}
				</div>
			),
		},
		{
			field: "year",
			headerName: "YEAR",
			width: 150,
			// editable: true,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell" >
					{data?.row?.class?.year || ""}
				</div>
			),
		},
		{
			field: "schoolGrade",
			headerName: "SCHOOL GRADE",
			width: 150,
			// editable: true,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell" >
					{data?.row?.class?.class_details?.grade}
				</div>
			),
		},
		{
			field: "registrationStatus",
			headerName: "REGISTRATION STATUS",
			width: 150,
			renderCell: (data) => <div className="row-data class-lits-table-cell">{data?.row?.registrationStatus !== "not-approve" ? data?.row?.registrationStatus : "-"}</div>,
		},
		{
			field: "PaymentStatus",
			headerName: "PAYMENT STATUS",
			// description: "This column has a value getter and is not sortable.",
			// sortable: false,
			width: 200,
			renderCell: (data) => (
				<StatusWrapper className="row-data class-lits-table-cell">
					<Status type={data?.row?.payment?.approve?.status}>
						<img src={data?.row?.payment?.approve?.status === "paid" ? PaidIcon : PendingIcon} alt="paid-icon"></img>{" "}
						{data?.row?.payment?.approve?.status || "pending"}
					</Status>
				</StatusWrapper>
			),
		},
		{
			field: "paidAmount",
			headerName: "PAID AMOUNT",
			width: 150,
			renderCell: (data) => (
				<div className="row-data class-lits-table-cell" style={{ color: "green" }}>
					{totalPaymentCalculation(data.row?.payment?.approve?.totalPaid, data.row?.payment?.register?.totalPaid)}
				</div>
			),
		},
	];

	const closeModal = () => {
    setConfirmClose(true);
  }
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setOpenDrawer(false);
  }

	return !isSchoolActive ? (
    <NotAuthorized title={"School"} />
  ) : (
		<div className="family-table-container">
			<div className="my-auto page-header">
				<Text className="sub-title pt-3" style={{ height: 44 }}>
					Education
				</Text>
			</div>
			<div className="home-table-container mt-0">
				<MyTable
					className="family-table education-account-table"
					rows={list}
					columns={columns}
					pageSize={30}
					loading={loading}
					rowHeight={70}
					onClickEvent={onClickEvent}
				></MyTable>
			</div>
			<div className="pagination-custom" style={{ marginTop: "20px" }}>
				<Pagination
					count={Math.ceil(total / 30)}
					color="primary"
					variant="outlined"
					onChange={(event, value) => {
						setPage(value - 1);
					}}
				/>
			</div>
			<RightDrawer
				open={openDrawer}
				onClose={closeModal}
			>
				<ParticipantDrawer
					drawerData={drawerData}
					closeModal={() => {
						setOpenDrawer(false);
					}}
					onSharePaymentLinkClick={onSharePaymentLinkClick}
				/>
			</RightDrawer>
				<Dialog
					open={openSharePaymentModal}
					onClose={() => {
						setOpenSharePayment(false);

					}}
					PaperProps={{
						style: {
							width: "888px",
							height: "637px",
							overflowX: "hidden",
							borderRadius: "22px",
						},
					}}
					fullWidth
					maxWidth={"md"}
				>
					<ShareDocumentsModal
						closeModal={() => {
							setOpenSharePayment(false);
						}}
						type={"sharePaymentLink"}
						accountId={dataRowSharePayment?.account?._id || ""}
						accountName={dataRowSharePayment?.account?.family_name || ""}
						participantId={dataRowSharePayment?._id || ""}
						defaultEmail={dataRowSharePayment?.account?.defaultEmails || []}
						documentType="paymentLink"
					/>
				</Dialog>
				<AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={confirmCloseHandler}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
		</div>
	);
};

export default School;
